/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Datumeinfuehrunglkk4Inputs */

const de__field_datumeinfuehrunglkk4 = /** @type {(inputs: _Field_Datumeinfuehrunglkk4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum Einführung LKK`)
};

/**

* @param {_Field_Datumeinfuehrunglkk4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_datumeinfuehrunglkk4 = /** @type {((inputs?: _Field_Datumeinfuehrunglkk4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Datumeinfuehrunglkk4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_datumeinfuehrunglkk4(inputs)
});
export { _field_datumeinfuehrunglkk4 as "_field_datumEinfuehrungLKK" }